module.exports = __webpack_public_path__ + "static/media/CBM-Logo-Sombra.eea0e239.png";